import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Statement } from "@/components/site/Statement";
import { Marquee } from "@/components/site/Marquee";
import { Metrics } from "@/components/site/Metrics";
import { Calculator } from "@/components/site/Calculator";
import { Process } from "@/components/site/Process";
import { Platforms } from "@/components/site/Platforms";
import { LeadQuality } from "@/components/site/LeadQuality";
import { Industries } from "@/components/site/Industries";
import { AboutPreview } from "@/components/site/AboutPreview";
import { SupportingServices } from "@/components/site/SupportingServices";
import { Results } from "@/components/site/Results";
import { AuditForm } from "@/components/site/AuditForm";
import { FinalCTA } from "@/components/site/FinalCTA";
import { Footer } from "@/components/site/Footer";
import { goToAudit } from "@/lib/scroll";

const MobileAuditCTA = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let auditVisible = false;
    const update = () => setShow(window.scrollY > 500 && !auditVisible);
    const audit = document.getElementById("audit");
    const obs = new IntersectionObserver(
      ([entry]) => {
        auditVisible = entry.isIntersecting;
        update();
      },
      { threshold: 0.02 }
    );
    if (audit) obs.observe(audit);
    window.addEventListener("scroll", update, { passive: true });
    update();
    return () => {
      obs.disconnect();
      window.removeEventListener("scroll", update);
    };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-4 bottom-4 z-40 lg:hidden"
        >
          <button
            type="button"
            data-testid="sticky-mobile-audit-cta"
            onClick={goToAudit}
            className="w-full rounded-full bg-purple-600 py-4 text-sm font-bold uppercase tracking-wide text-white shadow-xl shadow-black/50"
          >
            Get My Free Lead Audit
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="relative bg-[#05050A] text-white">
      <div className="vp-noise pointer-events-none fixed inset-0 z-[70] opacity-[0.03]" />
      <Navbar />
      <main>
        <Hero />
        <Statement />
        <Marquee />
        <Metrics />
        <Calculator />
        <Process />
        <Platforms />
        <LeadQuality />
        <Industries />
        <AboutPreview />
        <SupportingServices />
        <Results />
        <AuditForm />
        <FinalCTA />
      </main>
      <Footer />
      <MobileAuditCTA />
    </div>
  );
}
